import { Button } from '@chakra-ui/react';
import { AddCircleOutline } from '@aslanpay/portal-common-lib';
import { useRef } from 'react';

import { AddNewPhotoButtonProps } from './AddNewPhotoButton.types';

function AddNewPhotoButton({
  onChange,
  isDisabled,
  ctaText = 'Upload new photo',
}: AddNewPhotoButtonProps) {
  const ref = useRef<HTMLInputElement>(null);

  return (
    <>
      <input
        ref={ref}
        type="file"
        accept=".png,.jpg,.jpeg"
        multiple
        hidden
        onChange={(e) => {
          onChange?.(e);
          if (ref.current) ref.current.value = '';
        }}
      />
      <Button
        alignSelf="flex-start"
        variant="link"
        leftIcon={<AddCircleOutline boxSize="20px" />}
        onClick={() => ref.current?.click()}
        isDisabled={isDisabled}
        mt="12px"
        p="0"
      >
        {ctaText}
      </Button>
    </>
  );
}

export default AddNewPhotoButton;
